import { HeaderPillButton } from './HeaderPillButton';

export interface LoginPillProps {
  onClick?: () => void;
  label?: string;
}

/**
 * Modern Login pill — shown in the header's right slot in place of the
 * balance + MyPacks pills for anonymous embed visitors (no session token).
 * Tapping it opens the auth modal; on success the real pills return. Same
 * glass surface and size rhythm as {@link MyPacksPill} (via the shared
 * {@link HeaderPillButton}); the label stays visible on every breakpoint
 * (it's short enough not to need an icon-only mobile variant).
 */
export function LoginPill({ onClick, label = 'Login' }: LoginPillProps) {
  return (
    <HeaderPillButton
      onClick={onClick}
      ariaLabel={label}
      className="px-4 @[600px]:px-6"
    >
      {label}
    </HeaderPillButton>
  );
}
